"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvePlayerTimezoneOffsetMinutes = resolvePlayerTimezoneOffsetMinutes;
const VariableStore_1 = require("./VariableStore");
/** Player timezone offset in minutes east of UTC (matches ScriptContext). */
function resolvePlayerTimezoneOffsetMinutes(player, variableStore) {
    const fromPlayer = player.timeZoneOffsetMinutes;
    if (fromPlayer !== undefined && fromPlayer !== null && Number.isFinite(Number(fromPlayer))) {
        return Number(fromPlayer);
    }
    if (!variableStore) {
        return 0;
    }
    const ctx = VariableStore_1.VariableStore.buildVariableContext(player.id, player.characterName, player.currentScene, player.userId || 'anonymous');
    const raw = variableStore.getVariable('user_time_zone_offset_minutes', ctx);
    if (raw === undefined || raw === null) {
        return 0;
    }
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : 0;
}
//# sourceMappingURL=timerDeadlineHelpers.js.map